import { extractProperties } from './attributes';
import { emit } from './emitter';

const CLICK_SELECTOR = '[data-observe-id]';

const handleClick = (event: Event): void => {
  const target = (event.target as Element | null)?.closest(CLICK_SELECTOR);
  if (!target) return;

  const eventName = target.getAttribute('data-observe-id');
  if (!eventName) return;

  const properties = extractProperties(target);
  emit(eventName, properties);
};

export const initClickObserver = (): void => {
  // Event delegation handles all current and future elements — no MutationObserver needed
  document.addEventListener('click', handleClick);
};
